import React from "react";
import {
  Outlet,
} from "react-router-dom";
import { CompanyContextProvider } from "./../../contexts/CompanyContext";
import SidebarNav from "../SidebarNav";

import 'react-toastify/dist/ReactToastify.css';

function AppLayout() {
  return (
    <div className="d-flex">
      <div className="app-content">
        <CompanyContextProvider>
          <SidebarNav />
          <div className="main-content bg-lightgrey">
              <Outlet />
          </div>
        </CompanyContextProvider>
      </div>
    </div>
  );
};

export default AppLayout;